module.exports = __webpack_public_path__ + "media/Ora_GT_video.d21a3b1f.mp4";